<template>
    <div class="brief-container">
        <div class="bg-menu"></div>
        <PageTitle :title="title"></PageTitle>

            <form class="brief-form">

                <div class="form-row-flex">
                    <div class="form-col">
                        <div class="input-container">
                            <input type="text" v-model="prenom" placeholder="Prénom *" />
                        </div>
                    </div>
                    <div class="form-col">
                        <div class="input-container">
                            <input type="text" v-model="nom" placeholder="Nom *" />
                        </div>
                    </div>
                </div>

                <div class="form-row-flex">
                    <div class="form-col">
                        <div class="input-container">
                            <input type="email" v-model="email" placeholder="Email *" />
                        </div>
                    </div>
                    <div class="form-col">
                        <div class="input-container">
                            <input type="tel" v-model="telephone" placeholder="Téléphone *"  />
                        </div>
                    </div>
                </div>

                <div class="form-row-flex">
                    <div class="input-container">
                        <input type="text" class="input-full" v-model="societe" placeholder="Société *"  />
                    </div>
                </div>

                <div class="form-sep"></div>

                <div class="form-row">
                    <div class="input-container">
                        <label class="label-main"><span class="question-number">1.</span> Quel type de site souhaitez-vous ? *</label>
                        <div class="input-row margin-left">                        
                            <input type="checkbox" value="Site vitrine" v-model="type" />
                            <label>Site vitrine</label> 
                            <br />  
                            <input type="checkbox" value="Espace sécurisé" v-model="type" />
                            <label>Espace sécurisé</label> 
                            <br /> 
                            <input type="checkbox" value="Boutique" v-model="type" />
                            <label>Boutique e-Commerce</label> 
                            <br /> 
                            <div class="input-row row-tab" v-if="type.includes('Boutique')">  
                                <div class="input-container">
                                    <label class="label-main ">Combien y a-t-il de produits ? *</label>
                                    <input type="number" v-model="produit" />
                                </div>
                                <div class="input-container">
                                    <label class="label-main ">Combien y a-t-il de catégories ? *</label>
                                    <input type="number" v-model="categorie" />
                                </div>
                                <div class="input-container">
                                    <label class="label-main ">Quels moyens de paiement souhaitez-vous ? *</label>
                                    <div class="input-row margin-left">  
                                        <input type="checkbox" value="Module bancaire" v-model="paiement" />
                                        <label>Module carte bancaire de votre banque</label> 
                                        <br /> 
                                        <input type="checkbox" value="Paypal" v-model="paiement" />
                                        <label>Paypal</label> 
                                        <br /> 
                                        <input type="checkbox" value="Stripe" v-model="paiement" />
                                        <label>Stripe</label> 
                                        <br /> 
                                        <input type="checkbox" value="Virement" v-model="paiement" />
                                        <label>Par virement</label> 
                                        <br /> 
                                        <input type="checkbox" value="Autre" v-model="paiement" />
                                        <label>Autre</label> 
                                    </div>
                                </div>
                                <div class="input-container">
                                    <label class="label-main ">Où livrez-vous ? *</label>
                                    <div class="input-row margin-left">  
                                        <input type="checkbox" value="France" v-model="livraison" />
                                        <label>France</label> 
                                        <br /> 
                                        <input type="checkbox" value="Europe" v-model="livraison" />
                                        <label>Europe</label> 
                                        <br /> 
                                        <input type="checkbox" value="Monde entier" v-model="livraison" />
                                        <label>Monde entier</label> 
                                    </div>
                                </div>
                            </div>
                            <input type="checkbox" value="Plateforme Web" v-model="type" />
                            <label>Plateforme Web sur mesure (intranet, extranet, etc)</label> 
                        </div>
    
                    </div>
                </div>

                <div class="form-sep"></div>

                <div class="form-row">
                    <div class="input-container">
                        <label class="label-main "><span class="question-number">2.</span> Quelle audience ciblez-vous ? *</label>
                        <textarea rows="10" v-model="audience"></textarea>
                    </div>
                </div>


                <div class="form-sep"></div>

                <div class="form-row">
                    <div class="input-container">
                        <label class="label-main "><span class="question-number">3.</span> Avez-vous l'arborescence principale du site (menu et sous menu) ? *</label>
                        <div class="input-row margin-left">                        
                            <input type="radio" value="Oui" v-model="arbo" />
                            <label>Oui</label>   
                            <input type="radio" value="Non" v-model="arbo" />
                            <label>Non</label> 
                        </div>
                    </div>
                    <div class="input-container margin-left" v-if="arbo == 'Oui'">
                        <label class="label-main ">Veuillez préciser l'arborescence ? *</label>
                        <textarea rows="10" v-model="arboDetails"></textarea>
                    </div>
                    <div class="input-container margin-left" v-if="arbo == 'Non'">
                        <label class="label-main ">Veuillez préciser au moins le nombre de pages Web ? *</label>
                        <input type="number" v-model="pages" />
                    </div>
                </div>

                <div class="form-sep"></div>

                <div class="form-row">
                    <div class="input-container">
                        <label class="label-main "><span class="question-number">4.</span> Avez-vous le contenu de chaque page (textes et visuels) ? *</label>
                        <div class="input-row margin-left">                        
                            <input type="radio" value="Textes" v-model="contenu" />
                            <label>Textes</label>   
                            <input type="radio" value="Visuels" v-model="contenu" />
                            <label>Visuels</label> 
                            <input type="radio" value="Textes et visuels" v-model="contenu" />
                            <label>Textes & visuels</label> 
                            <input type="radio" value="Aucun" v-model="contenu" />
                            <label>Aucun</label> 
                        </div>
                    </div>
                </div>

                <div class="form-sep"></div>

                <div class="form-row">
                    <div class="input-container">
                        <label class="label-main "><span class="question-number">5.</span> Dans combien de langue souhaitez-vous votre site ? *</label>
                        <div class="input-row margin-left">                        
                            <input type="checkbox" value="Français" v-model="langue" />
                            <label>Français</label> 
                            <br />   
                            <input type="checkbox" value="Anglais" v-model="langue" />
                            <label>Anglais</label> 
                            <br /> 
                            <input type="checkbox" value="Allemand" v-model="langue" />
                            <label>Allemand</label> 
                            <br /> 
                            <input type="checkbox" value="Italien" v-model="langue" />
                            <label>Italien</label> 
                            <br /> 
                            <input type="checkbox" value="Espagnol" v-model="langue" />
                            <label>Espagnol</label>
                            <br /> 
                            <input type="checkbox" value="Autres" v-model="langue" />
                            <label>Autres</label>  
                        </div>
                    </div>
                    <div class="input-container margin-left" v-if="langue.includes('Autres')">
                        <label>Précisez SVP :</label>
                        <textarea rows="10" v-model="langueAutre"></textarea>
                    </div>
                </div>

                <div class="form-sep"></div>

                <div class="form-row">
                    <div class="input-container">
                        <label class="label-main "><span class="question-number">6.</span> Avez-vous déjà une charte graphique ? *</label>
                        <div class="input-row margin-left">                        
                            <input type="radio" value="Oui" v-model="charte" />
                            <label>Oui</label>   
                            <input type="radio" value="Non" v-model="charte" />
                            <label>Non</label> 
                        </div>
                    </div>
                </div>

                <div class="form-sep"></div>

                <div class="form-row">
                    <div class="input-container">
                        <label class="label-main"><span class="question-number">7.</span> Que souhaitez-vous pouvoir éditer vous-même sur le site ? *</label>
                        <div class="input-row margin-left">                        
                            <input type="radio" value="Tout le site" v-model="edition" />
                            <label>Tout le site</label>   
                            <input type="radio" value="News" v-model="edition" />
                            <label>News uniquement</label> 
                            <input type="radio" value="Aucun contenu" v-model="edition" />
                            <label>Aucun contenu</label> 

                        </div>
                    </div>
                </div>

                <div class="form-sep"></div>

                <div class="form-row">
                    <div class="input-container">
                        <label class="label-main"><span class="question-number">8.</span> Enfin, quelle stratégie de déploiement souhaitez-vous mettre en place ?<br />
                                <div class="label-light">Dans le cadre d'un site e-Commerce qui aura pour vocation de conquérir de nouveaux clients, il faudra définir une stratégie de référencement forte.<br />
                                Dans le cadre d'un site vitrine destiné aux clients existants, nous conseillons de voir le positionnement naturel du site au bout de 6 mois et de définir ensuite un plan d'action pour gagner de nouvelles positions. </div></label>
                        <textarea rows="10" v-model="strategie"></textarea>
                    </div>
                </div>
                
                <vue-recaptcha sitekey="6Lfqh7oUAAAAABtmQqjbl0R_-X7Q8jK8AD_BHjZc" :loadRecaptchaScript="true">

                </vue-recaptcha>

                <div class="form-row">
                    <input type="submit" class="btn-main" value="Envoyer" @click="sendEmail($event)"/>
                </div>

                <div v-if="errors" class="errors">
                    Le formulaire n'a pas pu être envoyé :
                    <ul>
                        <li v-for="(item, idx) in errorsMsg" :key="idx">{{ item }}</li>
                    </ul>
                </div>

                <div v-if="succes" class="succes">
                    Votre message a bien été envoyé.<br /> Nous vous recontacterons très prochaiement.
                </div>
            </form>    
    </div>
</template>

<script>
import PageTitle from './../layout/PageTitle'
import VueRecaptcha from 'vue-recaptcha';
import axios from 'axios'

export default {
    name: 'PriseBrief',
    components : {
        PageTitle, VueRecaptcha,
    },
    data() {
        return {
            title : 'Prise de Brief',
            type: [],
            produit: null,
            categorie : null,
            paiement : [],
            livraison : [],
            audience : null,
            arbo : null,
            arboDetails : null,
            pages : null,
            contenu : null,
            langue : [],
            langueAutre : null,
            charte : null,
            prive : null,
            edition : null,
            strategie : null,
            prenom : null,
            nom : null,
            email : null,
            telephone : null,
            societe :null,
            succes : false,
            errors : false,
            errorsMsg : []
        }
    },
    methods : {
        sendEmail(e) {
            e.preventDefault()
            this.errors = false
            this.succes = false
            this.errorsMsg = []

            let params = {
                 prenom  : this.prenom,
                 nom : this.nom,
                 email : this.email,
                 telephone : this.telephone,
                 societe : this.societe,
                 audience : this.audience,
                 boutique : this.boutique,
                 arbo : this.arbo,
                 pages : this.pages,
                 contenu : this.contenu,
                 langue : this.langue,
                 langueAutre : this.langueAutre,
                 charte : this.charte,
                 edition : this.edition,
                 strategie : this.strategie,
                 type : this.type,
                 paiement : this.paiement,
                 livraison : this.livraison,
                 produit : this.produit,
                 categorie : this.categorie,
                 arboDetails : this.arboDetails
            }
            let vm = this

            axios
                .post("https://www.synthes3dWeb.com/mailer/brief.php", params)
                .then(function(response){
                    if(response.data.state == 'succes') {
                        vm.succes  =true
                    } else {
                        vm.errors = true
                        vm.errorsMsg = response.data.retour
                    }
                })
        }
    }
}
</script>

<style scoped>
    .brief-container {
        margin-top:-100px;
        padding-bottom: 100px;
    }

    .brief-form {
        margin:80px auto;
        width:100%;
        max-width:1024px;
        padding-bottom:40px;
    }

    input[type="submit"] {
        border: none;
        margin:20px auto 0;
        padding: 10px 25px 10px 25px;
    }

    .form-row {
        margin : 20px 0;
    }

    .form-row-flex {
        margin : 20px 0;
        display: flex;
    }

    .form-col {
        width:50%;
        display: flex;
        flex-direction: column;
    }

    input[type="text"], input[type="email"], input[type="tel"], input[type="number"] {
        border:1px solid #e8e8e8;
        padding:10px 15px;
        width:calc(100% - 40px);
        margin: 0 10px 0 0;
    }

    .form-col:last-child input, .form-col:last-child label {
        margin: 0 0 0 10px;
    }

    label {
        color:#1a1a23;
        padding-bottom:5px;
        margin-right: 20px;
        display: inline-block;
        margin-top:10px;
    }

    textarea {
        width:100%;
    }

    .form-sep {
        height:1px;
        width:80%;
        margin: 40px auto;
        background: #e8e8e8;
    }

    .brief-form p {
        margin-bottom: 80px;
    }

    .input-container {
        width:100%;
    }

    input.input-full {
        margin: 0;
        width:calc(100% - 30px);
    }

    .errors {
        padding:20px;
        text-align: center;
        color:#f78c37;
        font-weight:bold;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .errors li {
        text-align: left;
    }

    .succes {
        padding:20px;     
        text-align: center;
        color:#92cd6b;
        font-weight:bold;
    }

    .row-tab {
        margin:0 0 15px 40px;
    }

    .row-tab label {
        font-size: 15px;
        margin-top:10px;
    }

    .question-number {
        font-size:20px;
        font-weight: 700;
        color:#f78c37;
    }

    .margin-left {
        margin-left:30px;
    }

    .label-main {
        font-weight:700;
    }

    .label-light {
        font-size:13px;
        font-style: italic;
        font-weight:400;
    }

    ::placeholder {
        font-style: italic;
    }

</style>